{
  "increasedQuantity": "增加数量",
  "decreasedQuantity": "减少数量",
  "rewardQuantity": "奖励数量",
  "jbpSystemOrderNumber": "JBP 系统订单号",
  "walletTransactionNumber": "钱包交易编号",
  "transactionId": "交易序号 (TxID)",
  "exchangeRate": "汇率",
  "exchangeRateFromUsdt": "1 USDT ≈ {{amount}} {{token}}",
  "transferInAmount": "转入数量",
  "convertedAmount": "兑换数量",
  "paymentQuantity": "支付数量",
  "receivedQuantity": "收币数量"
}
